export default __webpack_public_path__ + "8400e6db4dc03b9f7629e071165900a4.jpg";